import React, { Component } from 'react';
import { Header, List, Table } from 'semantic-ui-react';

export default class LeadingDiscussionsPage extends Component {
  render() {
    return (
      <div>
        <Header as="h1" content="Leading a discussion" />
        <p>
          <a
            href="https://docs.google.com/spreadsheets/d/1mcZB-FXjsFDOuKNiizlhn4VK4PyLL83rudcf_NHOnCY/edit?usp=sharing"
          target="_blank">Sign up for leading a discussion by commenting your name in the "Student
          column" of the linked spreadsheet.</a> Do so by 1/20 at the latest. I'll be making final
          assigninments by the end of week 2.
        </p>
        <p>
          Each student will summarize the readings and lead discussion for one class the semester.
          Aim for 30 minutes. Submit a draft of your slides / plan one week before the day of your lecture. 
          Note that for the class in which you are leading the discussion, you do not have to submit
          a reading commentary.
        </p>

        <p>
          Begin your discussion by defining a very clear learning goal for the class. What should
          students understand at the end of class that they may not have at the beginning? Decide
          on 3-4 key ideas from the readings that you would like the students to understand deeply,
          and structure your discussion strategy around that. As part of that, your discussion
          should accomplish the following:
        </p>

        <List bulleted>
          <List.Item>
            Lead a conversation about the papers, covering topics much like those that would be
            covered in a critique. You don't need to provide all the content, but you need to
            be willing to step in at any point when no one else is providing the content. Don't
            plan on giving a 30-minute monologue. Do come in with a clear set of goals for what
            you would like to convey.
          </List.Item>
          <List.Item>
            Get people talking! One great way to do this is to break people into pairs or small
            groups for a minute or two to think about a question. Pairs and small groups give
            more students a chance to participate, and they help students get ideas and words
            flowing.
          </List.Item>
          <List.Item>
            Cover both high- and low-level parts of the readings. What does this research mean?
            High level concepts are important, they help us anchor on the topic and give us
            some motivation for a research topic. How was this research accomplished? What technical
            concepts and methodological strategies were employed? Dive into a key detail of how a
            study was performed, or whether the right research question was asked. If it's a
            technical paper, the discussion should help students deeply understand the key technical
            ideas.
          </List.Item>
          <List.Item>
            Importantly, do not simply summarize the readings. That’s boring for everyone, as everyone
            should have already done the reading themselves. Add your own commentary in a manner that
            you believe will help your classmates learn.
          </List.Item>
          <List.Item>
            Before class on the day of your discussion, read through all other students' commentaries and
            weave ideas from them into your discussion, crediting the authors. It's a nice way to
            encourage the excellent, thoughtful work that students do in writing their commentaries,
            and also bring those ideas and their authors into the class time discussion. To view other
            students’ commentaries, you may need to write something on the Canvas discussion thread first
            - just write some placeholder text like “I’m the discussion leader for this reading.”
          </List.Item>
        </List>

        <Header as="h2" content="Deliverable" />
        <p>
          Submit your slides on Canvas the day you are scheduled to lead the discussion for class.
        </p>

        <Header as="h2" content="Grading" />
        <p>
          I will evaluate your discussion along three dimensions using the following rubric:
        </p>

        <Table definition>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell />
              <Table.HeaderCell>Insufficient</Table.HeaderCell>
              <Table.HeaderCell>Adequate</Table.HeaderCell>
              <Table.HeaderCell>Proficient</Table.HeaderCell>
              <Table.HeaderCell>Mastery</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            <Table.Row>
              <Table.Cell>Insight (7 pts)</Table.Cell>
              <Table.Cell>
                No meaningful questions raised about the reading in the public forum (1 pt).
              </Table.Cell>
              <Table.Cell>
                Questions and insights posed for discussion were straightforward extensions of the papers (3 pts).
              </Table.Cell>
              <Table.Cell>
                Raised questions and insights that demonstrated some critical thinking, but some points were somewhat shallow (5 pts).
              </Table.Cell>
              <Table.Cell>
                Raised questions and insights to the class that displayed clarity of thought and prompted new perspectives on the papers (7 pts).
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>Integration (4 pts)</Table.Cell>
              <Table.Cell>
                Students' commentaries were not integrated or barely integrated (1 pt).
              </Table.Cell>
              <Table.Cell>
                Students' commentaries were integrated in a surface-level fashion (2 pts).
              </Table.Cell>
              <Table.Cell>
                Students' commentaries reinforced the main points of the paper but did not add significant color or spark new discussion (3 pts).
              </Table.Cell>
              <Table.Cell>
                Students' commentaries were woven into the presentation to add color and perspective to the discussion points and spark in-class discussion (4 pts).
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>Conversation and Activities (7 pts)</Table.Cell>
              <Table.Cell>
                Let the conversation drift, asked questions too open-ended and prompted a lot of
                dead time during discussion, or otherwise produced a poorer in-class learning
                experience (1 pt).
              </Table.Cell>
              <Table.Cell>
                Questions elicited a response but did not spur discussion. Activities were
                mildly useful in enhancing learning (3 pts).
              </Table.Cell>
              <Table.Cell>
                Guided the students' discussion toward active participation and conversation.
                Activities were well motivated (5 pts).
              </Table.Cell>
              <Table.Cell>
                Guided the students' discussion toward active participation and conversation.
                Activities increased engagement with material and broadened student's
                understanding of the subject (7 pts).
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/leading-discussions-page.js